import Styled from 'styled-components';

import { media, theme, VALID_BREAKPOINTS } from '../../../lib/StyledComponents';

const breakPoint: VALID_BREAKPOINTS = theme.header.subNavBreakPoint;

export const HeaderSubNavSummary = Styled.div`
  order: 1;
  padding: 0.75em 1em;

  ${media[breakPoint]`
    flex: 0 1 40%;
    padding: 0.75em 0 0.75em 1em
    align-self: center;
  `}
`;

export const HeaderSubNavSummaryLabel = Styled.strong`
  display: block;
  margin-bottom: 0.25em;
  font-weight: ${({ theme: { header } }) => header.summaryWeight};

  ${media[breakPoint]`
    text-align: right;
  `}
`;

export const HeaderSubNavSummaryDataList = Styled.ul`
  display: flex;
  justify-content: flex-start;

  ${media[breakPoint]`
    justify-content: flex-end;
  `}

  li {
    padding: 0;
  }

  li:not(:last-child)::after {
    content: '\\2219';
    padding: 0 0.5em;
    font-weight: 700;
  }
`;

export const HeaderSubNavSummaryDataPoint = Styled.span`
  margin: 0;
  display: inline;
  white-space: nowrap;
`;

HeaderSubNavSummary.displayName = 'HeaderSubNavSummary';
HeaderSubNavSummaryLabel.displayName = 'HeaderSubNavSummaryLabel';
HeaderSubNavSummaryDataList.displayName = 'HeaderSubNavSummaryData';
HeaderSubNavSummaryDataPoint.displayName = 'HeaderSubNavSummaryDataPoint';
